// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 7776 ? "477d4af2" : chunkId) + "." + {"1429":"dff6d6060aebd910","5539":"beeed9f93cc4b6f3","7776":"b4fe52d4e702e323"}[chunkId] + ".js";
};